<template>
  <div class="app-main-content">
    <div>
      <h1>Update Paperless Enrollment</h1>
      <div><SystemAlert/></div>
      <slot>
        <CommunicationUpdate />
      </slot>
    </div>
  </div>
</template>

<script setup>
import {  onBeforeUnmount } from 'vue';
import SystemAlert from '@/components/SystemAlert';
import CommunicationUpdate from '../../components/updateCommunication/CommunicationUpdate.vue';

// Lifecycle hook 
onBeforeUnmount(() => {

});
</script>